import { URISerializers } from './uri_definitions/serializers';
/**
 * Returns the components of a URI as an array.
 *
 * @param uri - An uri.
 * @param format - The output URIformat.
 * @returns An array of uri components.
 */
export function getComponents(uri, format) {
    const uriSerializer = URISerializers[uri.type];
    if (!uriSerializer) {
        throw new TypeError('Invalid Spotify URI!');
    }
    return uriSerializer(uri, format);
}
//# sourceMappingURL=utils.js.map